import { render, staticRenderFns } from "./backup-panel.vue?vue&type=template&id=0419a81d&scoped=true"
import script from "./backup-panel.vue?vue&type=script&lang=ts"
export * from "./backup-panel.vue?vue&type=script&lang=ts"
import style0 from "./backup-panel.vue?vue&type=style&index=0&id=0419a81d&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0419a81d",
  null
  
)

export default component.exports